export default "__VITE_ASSET__CzjW8OUh__"